<template>
<div id="app">
  <div class="content-div">
    <router-view/>
  </div>
  </div>
</template>

<script>
    export default {
      data(){
        return{

        }
      },
      components: {

      },
      computed: {

      },
      created() {
        var _this = this;
      }
    }
</script>
<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    max-width: 750px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
  }

  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }
  .content-div{
    width: 100%;
    min-height: 100vh;
  }

</style>
